import React from 'react';
import { useLocation } from 'react-router-dom';

import { AppLogo } from 'app/components/AppLogo';
import { LoggedUserMenu } from 'app/components/LoggedUserMenu';
import { LoginButton } from 'app/components/LoginButton';
import { HamburgerAppMenu } from 'app/components/HamburgerAppMenu';
import { useStyles } from './FirstStepModePageHeader.styles';
import { ItemInterface } from 'app/components/AppMenu/AppMenu.interfaces';
import { FirstStepEnum, RouteEnum, MenuItemsEnum } from 'app/shared/enums';
import { agencyMode } from 'app/services/env.service';
import { useUser } from 'app/shared/hooks/useUser';
import { useLogout } from 'app/shared/hooks/useLogout';
import { wasPrerendered } from 'app/shared/helpers/isPrerendering';

import { FirstStepModePageHeaderProps } from './FirstStepModePageHeader.interfaces';

export default function FirstStepModePageHeader(
  props: FirstStepModePageHeaderProps
) {
  const location = useLocation();
  const logout = useLogout(RouteEnum.CALCULATION_FORM);

  const { checkingAuth, isLoggedIn, isOperator, userRoute } = useUser();

  const classes = useStyles();

  const items: ItemInterface[] = [
    {
      to: RouteEnum.CALCULATION_FORM,
      title: MenuItemsEnum.OcAcCalculator,
      visible: !agencyMode,
    },
  ].filter((item) => item.visible);

  const itemsMobile = [
    ...items,
    {
      to: {
        pathname: RouteEnum.LOGIN,
        state: {
          modal: true,
          from: location.pathname,
        },
      },
      title: MenuItemsEnum.LogIn,
      visible: !isLoggedIn,
    },
    {
      to: {
        pathname: userRoute,
      },
      title: MenuItemsEnum.MyAccount,
      visible: isLoggedIn && !isOperator,
    },
    {
      onClick: logout,
      title: MenuItemsEnum.LogOut,
      visible: isLoggedIn,
    },
  ].filter((item) => item.visible);

  return (
    <div className={classes.wrapper}>
      <div className={classes.logoContainer}>
        <div></div>
        <a href={'/'} target="_blank" rel="noopener noreferrer">
          <AppLogo width={120} height={40} />
        </a>
        <div className={classes.loginButtonContainer}>
          {(!checkingAuth || wasPrerendered) &&
            (isLoggedIn ? (
              <LoggedUserMenu />
            ) : (
              <LoginButton
                rounded
                className={classes.loginButton}
                isInactive={checkingAuth}
              />
            ))}
          {!!itemsMobile.length && (
            <HamburgerAppMenu
              loggedIn={isLoggedIn}
              classes={{
                root: classes.hamburgerMenu,
              }}
              items={itemsMobile}
              isInFirstStepMode
            />
          )}
        </div>
      </div>
      <h1>{FirstStepEnum.TitlePart1}</h1>
      <span className={classes.subtitle}>{FirstStepEnum.TitlePart2}</span>
    </div>
  );
}
